import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 2.3rem;
  font-weight: bold;
  font-family: var(--poppins);
  margin-top: 80px;
  color: var(--white);
  text-align: center;
  span {
    color: var(--secondary);
  }
  @media screen and (max-width: 500px) {
    font-size: 2rem;
  }
`;

export const TitleService = styled.h1`
  font-size: 2.3rem;
  font-weight: bold;
  font-family: var(--poppins);
  margin-top: 5px;
  padding-bottom: 15px;
  color: var(--white);
  text-align: center;
  span {
    color: var(--secondary);
  }
  @media screen and (max-width: 500px) {
    font-size: 2rem;
  }
`;

export const Subtitle = styled.button`
  background: none;
  height: 60px;
  width: auto;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-size: 2rem;
  font-family: var(--poppins);
  color: var(--white);
  text-align: center;
  line-height: 1.1;
  span {
    font-size: 1.4rem;
    color: var(--secondary);
  }
  @media screen and (max-width: 500px) {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    font-size: 1rem;
    text-align: left;
    width: 200px;
    height: fit-content;
    margin-top: 10px;
    margin-left: 15px;
    padding: 0;
  }
`;

export const SubtitleFinish = styled.button`
  background: none;
  height: 42px;
  width: auto;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-size: 1.5rem;
  font-family: var(--poppins);
  color: var(--white);
  text-align: center;
  line-height: 1.1;
  span {
    font-size: 1.2rem;
    color: var(--secondary);
  }
  @media screen and (max-width: 771px) {
    font-size: 0.7rem;
    height: fit-content;
  }
`;

export const SubtitleFinishBold = styled.text`
  background: none;
  height: 60px;
  width: auto;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-size: 1.9rem;
  font-family: var(--poppins);
  color: var(--white);
  text-align: center;
  line-height: 1.1;
  font-weight: bold;
  margin-inline: 6px;
  span {
    font-size: 1.2rem;
    color: var(--secondary);
  }
  @media screen and (min-width: 500px) and (max-width: 771px) {
    font-size: 1rem;
    height: fit-content;
    width: 130px;
  }

  @media screen and (max-width: 500px) {
    font-size: 0.8rem;
    height: fit-content;
    min-width: 100px;
    width: 100px;
    margin-inline: 6px;
  }
`;

export const Text = styled.h4`
  font-size: 1rem;
  font-family: var(--poppins);
  margin-top: 80px;
  color: var(--white);
  text-align: center;
  font-weight: normal;
  span {
    color: var(--secondary);
  }
`;

export const TextCircle = styled.h4`
  font-size: 1rem;
  font-family: var(--poppins);
  color: var(--white);
  text-align: center;
  font-weight: normal;
  margin-bottom: 20px;
  padding: 0;
  span {
    color: var(--secondary);
  }
  @media screen and (max-width: 500px) {
    font-size: '0.73rem';
    text-align: left;
    margin-top: 5px;
    padding: 5px;
    margin-left: 10px;
    max-width: 85%;
  }
  @media screen and (min-width: 1363px) {
    font-size: 0.9rem;
  }
`;

export const TextBudget = styled.h4`
  max-width: 630px;
  font-size: 1rem;
  font-family: var(--poppins);
  color: var(--white);
  text-align: center;
  font-weight: normal;
  margin-bottom: 20px;
  padding: 0;
  span {
    color: var(--secondary);
  }
  @media screen and (max-width: 500px) {
    font-size: '0.85rem';
    text-align: center;
    margin-top: 5px;
    padding: 5px;
    max-width: 85%;
  }
  @media screen and (min-width: 1363px) {
    font-size: 0.9rem;
  }
`;

export const CardAnchor = styled.div`
  font-size: 1.2rem;
  font-family: var(--poppins);
  color: var(--white);
  position: absolute;
  bottom: 25px;
  font-weight: bold;
  width: calc(100% - 20px);
  text-align: center;
  span {
    color: var(--secondary);
  }
`;
